/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import {
  Box, makeStyles,
} from '@material-ui/core';
import { React } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import PageBanner from '../../components/utils/PageBanner';
import SimpleAlert from '../../components/utils/SimpleAlert';
import DeploymentAccordion from '../../components/DeploymentList/DeploymentAccordion';
import GraphqlService from '../../service/graphqlService';
import MessageCard from '../../components/utils/MessageCard';
import ProgressDialog from '../../components/utils/ProgressDialog';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.default,
  },
  backButton: {
    marginBottom: theme.spacing(2),
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));


export default function DeploymentDetail() {
  const { projectCode, deploymentId } = useParams();
  const history = useHistory();
  const classes = useStyles();

  const getDeployment = async (deploymentID) => GraphqlService.getDeployment({
    // format projectCode to Number
    projectId: Number(projectCode),
    deploymentID,
  });

  const {
    data: deployment,
    error: errorFetchingDeployment,
    isLoading,
  } = useQuery(['deployment', projectCode, deploymentId], () => getDeployment(deploymentId), {
    enabled: !!deploymentId && !!projectCode,
    cacheTime: 0,
  });

  const handleBackClick = () => {
    history.push('/deployments');
  };

  if (!projectCode) {
    return <MessageCard message="No project selected" />;
  }

  if (errorFetchingDeployment) {
    return (
      <SimpleAlert
        open={true}
        setOpen={() => { }}
        header="Error"
        body={errorFetchingDeployment.message}
        id="closeAlertErrorFetchingDeployment"
      />
    );
  }

  return (
    <Box className={classes.container}>
      {(isLoading) && (
        <ProgressDialog open header="Retrieving deployment details, please wait" />
      )}

      <div className={classes.title}>
        <PageBanner
          title={`DEPLOYMENT DETAIL`}
        />
      </div>

      {deployment ? (
        <DeploymentAccordion
          deployment={deployment}
          key={deployment.deploymentID}
          id={`deploymentDetail${deployment.deploymentID}`}
          deleted={false}
          deleteDeploy={() => { }} // Disable delete in detail view
          expandedProp={true} // Always expanded in detail view
        />
      ) : !isLoading ? (
        <MessageCard message="Deployment not found" />
      ) : null}
    </Box>
  );
}